module.exports = __webpack_public_path__ + "img/fsh_fishtankdao.217f1f2.png";